import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { EstablishmentInfrastructureValidationSchema } from '@/features/maintenance/establishmentInfrastructures/schemas/create.schema'
import { useMutation } from '@tanstack/react-query'

interface UseUpdateEstablishmentInfrastructureProps {
  id: string
  onSuccess: () => void
  onError: (error: ErrorResponse) => void
}

export const useUpdateEstablishmentInfrastructure = ({
  id,
  onSuccess,
  onError,
}: UseUpdateEstablishmentInfrastructureProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateEstablishmentInfrastructure'],
    mutationFn: async (form: EstablishmentInfrastructureValidationSchema) =>
      privateAxios.put(`/maintenance/establishment_infrastructures/${id}`, form),
    onSuccess,
    onError,
  })
}
